
import { Shield } from "lucide-react";

interface HebrewLoanInfoNoticesProps {
  isSubmitting: boolean;
}

export const HebrewLoanInfoNotices = ({ isSubmitting }: HebrewLoanInfoNoticesProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-start space-x-2 rtl:space-x-reverse bg-blue-50 p-3 rounded-md">
        <Shield className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
        <div className="text-xs text-blue-700">
          <p className="font-medium mb-1">המידע שלך מאובטח</p>
          <p>אנו משתמשים בהצפנת SSL כדי להבטיח שכל הנתונים שלך מוגנים. לעולם לא נשתף את המידע שלך עם צדדים שלישיים ללא הרשאה.</p>
        </div>
      </div>
      
      <p className="text-xs text-center text-gray-600">
        שליחת הבקשה לא תשפיע על דירוג האשראי שלך. זה לוקח רק 2 דקות, והצעות ההלוואה יתחילו להופיע תוך שעות.
      </p>
    </div>
  );
};
